import {addMilliseconds} from 'date-fns';
import {getTimezoneOffset} from 'date-fns-tz';
import {DISPLAY_TIMEZONE} from './constants';

export const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

/**
 * Convert a date between two timezones. Result date will believe it is in UTC
 * @param date
 * @param param1
 * @returns
 */
export function convertTimezone(
  date: Date,
  {from, to}: {from: string; to: string},
) {
  return addMilliseconds(date, getTimezoneOffset(to) - getTimezoneOffset(from));
}
